import { render } from "./apiManagement.vue?vue&type=template&id=07c32c0f&scoped=true"
import script from "./apiManagement.vue?vue&type=script&lang=js"
export * from "./apiManagement.vue?vue&type=script&lang=js"

import "./apiManagement.vue?vue&type=style&index=0&id=07c32c0f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c32c0f"]])

export default __exports__